<template>
  <v-app id="epd-archive">
    <Toolbar/>
    <DrawerLeft/>
    <Dialog/>
    <v-content>
      <SearchModal/>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
/* tslint:disable:no-console */
import Dialog from './components/Dialog';
import DrawerLeft from './components/DrawerLeft';
import ListView from './components/ListView';
import Toolbar from './components/Toolbar';
import SearchModal from './components/SearchModal';

import goTo from 'vuetify/es5/services/goto';

export default {
  name: 'App',
  components: {
    Dialog,
    DrawerLeft,
    ListView,
    Toolbar,
    SearchModal,
  },
  data() {
    return {
      drawer: null,
      tokenInterval: null,
    };
  },
  props: {
    source: String,
  },
  mounted() {
    this.$store.dispatch('updateList', {limit: 100, offset: 0});
    this.tokenInterval = setInterval(this.checkToken, 20 * 1000); // 20 seconds
  },
  destroyed() {
    clearInterval(this.tokenInterval);
  },
  methods: {
    checkToken() {
      const payload = this.$store.state.app.userTokenPayload;
      const rightNow = Math.floor(new Date().getTime() / 1000);
      const restLife = payload.exp - rightNow;

      // auto renew token if stayLoggedIn active and JWT expires in < 10 min
      if (restLife < 600 && this.$store.state.app.userSettings.stayLoggedIn) {
        this.fetchToken();
      }

      // check token lifetime and log out user if expired
      if (rightNow > payload.exp) {
        this.$store.commit('setUserAuthenticated', false);
        this.$router.push('/');
      }
    },
    async fetchToken() {
      const URL = process.env.VUE_APP_AUTH_URL;
      const response = await fetch(URL + '/auth/refresh', {
        method: 'POST',
        withCredentials: true,
        credentials: 'include',
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.app.jwt,
          'Content-Type': 'application/json',
        },
      });
      try {
        if (response.status === 401) {
          this.$store.commit('setUserAuthenticated', false);
          this.$router.push('/');
        }
        const json = await response.json();
        if (json.token) {
          this.$store.commit('setJWT', json.token);
        }
      } catch (err) {
        console.error(err);
      }
    },
    refresh() {
      goTo(0);
    },
  },
};
</script>

<style lang="less">
html {
  overflow: hidden;
}
.new-listitems {
  margin: 20px auto;
  z-index: 99;
  left: 50%;
  transform: translateX(-50%);
}
.v-application--wrap {
  height: 100vh;
}
.v-content, .v-content__wrap, .home {
  height: 100%;
}

@media print {
  #main-toolbar, #list-panel, button {
    display: none;
  }
  main.v-content {
    padding-top: 0 !important;
  }
  #detail-panel {
    width: 100vw;
    max-width: 100vw;
    flex: none;
    height: auto;
  }
}
</style>
